import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ValidationRuleToken } from './models/validation-rules';
import { ContextualizeColumnsPipe } from './pipes/contextualize-columns.pipe';
import { FilterHiddenColumnsPipe } from './pipes/filter-hidden-columns.pipe';
import { CatalogFormBuilderService } from './services/catalog-form-builder.service';
import { CatalogsService } from './services/catalogs.service';
import { SectionValidatorService } from './services/section-validator.service';
import { SubsectionMakerService } from './services/subsection-maker.service';
import { UserCatalogsService } from './services/user-catalogs.service';
import { noValidate } from './utils/no-validate';
import { ContextualizeColumnPipe } from './pipes/contextualize-column.pipe';
import { ContextualizeColumnFormControlOptionsPipe } from './pipes/contextualize-column-form-control-options.pipe';
import { DataColumnFormatterPipe } from './pipes';

@NgModule({
  imports: [CommonModule],
  declarations: [
    FilterHiddenColumnsPipe,
    ContextualizeColumnsPipe,
    ContextualizeColumnPipe,
    ContextualizeColumnFormControlOptionsPipe,
    DataColumnFormatterPipe,
  ],
  providers: [
    SubsectionMakerService,
    SectionValidatorService,
    CatalogsService,
    UserCatalogsService,
    CatalogFormBuilderService,
    { provide: ValidationRuleToken, useValue: noValidate, multi: true },
  ],
  exports: [
    FilterHiddenColumnsPipe,
    ContextualizeColumnsPipe,
    ContextualizeColumnPipe,
    ContextualizeColumnFormControlOptionsPipe,
    DataColumnFormatterPipe,
  ],
})
export class MiqCatalogModule {}
